[
  {
    "id": "straznik",
    "name": "Strażnik",
    "description": "Rycerz w ciężkiej zbroi. Tnie mieczem szeroko przed sobą i odpycha wrogów, tarcza trzyma go przy życiu.",
    "color": "#c9a24a",
    "visual": "knight",
    "baseStats": {
      "maxHealth": 160,
      "moveSpeed": 110,
      "pickupRadius": 60,
      "critChance": 0.05,
      "armor": 10,
      "regen": 0.6
    },
    "startingAbilities": [
      "ciecie"
    ],
    "startingItems": [
      "miecz-rycerski",
      "tarcza-okragla"
    ]
  },
  {
    "id": "barbarzynca",
    "name": "Barbarzyńca",
    "description": "Dziki wojownik. Wiruje z toporem w środku hordy, im bliżej wrogów, tym lepiej.",
    "color": "#d86b4a",
    "visual": "barbarian",
    "baseStats": {
      "maxHealth": 180,
      "moveSpeed": 115,
      "pickupRadius": 60,
      "critChance": 0.08,
      "armor": 4,
      "regen": 0.4
    },
    "startingAbilities": [
      "rabanie"
    ],
    "startingItems": [
      "topor-bojowy"
    ]
  },
  {
    "id": "arkanista",
    "name": "Arkanista",
    "description": "Kruchy mag. Razi z daleka kulami energii, ogniem i lodem.",
    "color": "#5aa9e6",
    "visual": "mage",
    "baseStats": {
      "maxHealth": 100,
      "moveSpeed": 125,
      "pickupRadius": 80,
      "critChance": 0.08,
      "armor": 0,
      "regen": 0.2
    },
    "startingAbilities": [
      "iskra"
    ],
    "startingItems": [
      "rozdzka"
    ]
  },
  {
    "id": "tropiciel",
    "name": "Tropiciel",
    "description": "Zwinny strzelec. Bełty z kuszy przebijają cele, a noże czyszczą to, co podejdzie za blisko.",
    "color": "#6bbf59",
    "visual": "rogue",
    "baseStats": {
      "maxHealth": 120,
      "moveSpeed": 135,
      "pickupRadius": 70,
      "critChance": 0.12,
      "armor": 3,
      "regen": 0.3
    },
    "startingAbilities": [
      "grot"
    ],
    "startingItems": [
      "kusza"
    ]
  }
]
